/**
 * useListingFilterBarControllers — filter bar controller callbacks.
 *
 * A5 from listing-abstraction-opportunities.md
 *
 * Encapsulates the "narrowing clears selection" rule, Manage Filters toggle,
 * Reset Filters, and Reset Cache confirm-reload pattern shared by every
 * FilterBar listing.
 */
import { useCallback, useState } from 'react';
export function useListingFilterBarControllers({ setFilters, initialFilters, initialActiveFilterKeys, clearSelection, clearPreferences, confirmResetCache, reloadOnResetCache = true }) {
    const [activeFilterKeys, setActiveFilterKeys] = useState(initialActiveFilterKeys);
    const handleFiltersChange = useCallback((f) => {
        setFilters(f);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
    }, [setFilters, clearSelection]);
    const handleFilterToggle = useCallback((field) => {
        setActiveFilterKeys((prev) => (prev.includes(field) ? prev.filter((k) => k !== field) : [...prev, field]));
    }, []);
    const handleResetFilters = useCallback(() => {
        setFilters(initialFilters);
        setActiveFilterKeys([...initialActiveFilterKeys]);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
    }, [setFilters, initialFilters, initialActiveFilterKeys, clearSelection]);
    const handleResetCache = useCallback(() => {
        const confirm = confirmResetCache !== null && confirmResetCache !== void 0 ? confirmResetCache : (() => {
            const w = window;
            const msg = w.I18n ? w.I18n.t('generic.confirm') : 'Are you sure?';
            // eslint-disable-next-line no-alert
            return window.confirm(String(msg));
        });
        if (!confirm())
            return;
        clearPreferences();
        if (reloadOnResetCache) {
            window.location.reload();
        }
    }, [confirmResetCache, clearPreferences, reloadOnResetCache]);
    return {
        activeFilterKeys,
        setActiveFilterKeys,
        handleFiltersChange,
        handleFilterToggle,
        handleResetFilters,
        handleResetCache
    };
}
